import { render } from "./CampaignStatusChip.vue?vue&type=template&id=0d19b961&scoped=true"
import script from "./CampaignStatusChip.vue?vue&type=script&lang=js"
export * from "./CampaignStatusChip.vue?vue&type=script&lang=js"

import "./CampaignStatusChip.vue?vue&type=style&index=0&id=0d19b961&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d19b961"]])

export default __exports__